import { render, staticRenderFns } from "./FooterSectionEN.vue?vue&type=template&id=b317038e&scoped=true"
import script from "./FooterSectionEN.vue?vue&type=script&lang=js"
export * from "./FooterSectionEN.vue?vue&type=script&lang=js"
import style0 from "./FooterSectionEN.vue?vue&type=style&index=0&id=b317038e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b317038e",
  null
  
)

export default component.exports